module.exports = __webpack_public_path__ + "img/france-lung-cancer-male.d76ec862.png";